import { render, staticRenderFns } from "./maintain-internal-news.vue?vue&type=template&id=d8e8c372"
import script from "./maintain-internal-news.vue?vue&type=script&lang=js"
export * from "./maintain-internal-news.vue?vue&type=script&lang=js"
import style0 from "./maintain-internal-news.vue?vue&type=style&index=0&id=d8e8c372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports